import styled, { css, keyframes } from 'styled-components';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

const dotsAnimation = keyframes`
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
`;

type WrapperProps = {
  $color?: ThemeColorType;
  isPaused?: boolean;
};

export const Wrapper = styled.span<WrapperProps>`
  ${({ isPaused }) => `
    --cursor: ${isPaused ? 'pointer' : 'unset'};
  `};
  color: ${({ $color = 'iconGray', theme }) => theme.colors[$color]};
  cursor: var(--cursor);
  font: normal 400 12px/20px ${({ theme }) => theme.fonts.fontFamily};
  opacity: 0.65;
  position: relative;

  &::after {
    animation: ${({ isPaused }) =>
      isPaused
        ? 'none'
        : css`
            ${dotsAnimation} 2s linear infinite
          `};
    content: '';
    display: inline-block;
    left: 100%;
    overflow: hidden;
    position: absolute;
  }
`;
